<template>
  <action-message :on="showToast" :error="true" :message="toastMessage" />
  <TransitionRoot as="template" :show="isOpen">
    <Dialog as="div" class="fixed inset-0 zoom-80 z-10 overflow-y-auto" @close="closeModal">
      <div
        class="
          flex
          items-center
          justify-center
          min-h-screen
          px-4
          pt-4
          pb-20
          text-center
          sm:block
          sm:p-0
        "
      >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
          &#8203;
        </span>

        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            class="
              inline-block
              overflow-hidden
              text-left
              align-bottom
              transition-all
              transform
              bg-white
              rounded-lg
              shadow-xl
              sm:my-8
              sm:align-middle
              sm:max-w-lg
              sm:w-full
              p-6
            "
          >
            <DialogTitle as="h3" class="text-lg font-medium leading-6 text-gray-900">
              Are you sure you want to delete the device?
            </DialogTitle>
            <div class="mt-5 sm:mt-6 sm:flex sm:flex-row-reverse">
              <button
                type="button"
                class="
                  inline-flex
                  justify-center
                  w-full
                  rounded-md
                  border border-transparent
                  shadow-sm
                  px-4
                  py-2
                  bg-red-600
                  text-base
                  font-medium
                  text-white
                  hover:bg-red-700
                  focus:outline-none
                  focus:ring-2 focus:ring-offset-2 focus:ring-red-500
                  sm:ml-3
                  sm:w-auto
                  sm:text-sm
                "
                @click="deleteDevice"
              >
                Delete
              </button>
              <button
                type="button"
                class="
                  mt-3
                  w-full
                  inline-flex
                  justify-center
                  rounded-md
                  border border-gray-300
                  shadow-sm
                  px-4
                  py-2
                  bg-white
                  text-base
                  font-medium
                  text-gray-700
                  hover:bg-gray-50
                  focus:outline-none
                  focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
                  sm:mt-0
                  sm:w-auto
                  sm:text-sm
                "
                @click="closeModal"
              >
                Cancel
              </button>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { ref, watch } from 'vue';
import {
  Dialog,
  DialogOverlay,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue';
import ActionMessage from '@/Jetstream/ActionMessage.vue';
import useDeviceAndSessionSetupStore from '@/Stores/useDeviceAndSessionSetupStore';
import { DEVICE_SLOT_ACTIONS } from '@/Utils/vice-constants';
import useEventsBus from '@/Services/EventBus.js';

export default {
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    ActionMessage,
  },
  setup() {
    const isOpen = ref(false);
    const deviceSlotId = ref(null);

    const showToast = ref(false);
    const toastMessage = ref('Device deletion error');

    const deviceAndSessionSetupStore = useDeviceAndSessionSetupStore();

    const { bus, emit } = useEventsBus();

    const closeModal = () => {
      isOpen.value = false;
    };

    // Handle "Delete" button
    const deleteDevice = () => {
      axios
        .delete(route('clinician.delete-device', { useCaseSlotId: deviceSlotId.value }))
        .then(() => {
          // emit event when clinician deleted device from slot
          emit('deviceDeletedFromDeviceTypeSlot', {
            deviceSlotId: deviceSlotId.value,
          });

          // delete from Pinia
          deviceAndSessionSetupStore.manageClinicianDeviceSlot(
            deviceSlotId.value,
            DEVICE_SLOT_ACTIONS.DELETE_DEVICE,
          );

          closeModal();
        })
        .catch((e) => {
          console.log(e);
          showToast.value = true;
        });
    };

    // listen to event when clinician trying to delete device from slot
    watch(
      () => bus.value.get('showDeleteDevicesModal'),
      (deviceSlotPropertiesArgs) => {
        isOpen.value = true;
        deviceSlotId.value = deviceSlotPropertiesArgs[0].deviceSlotId;
      },
    );

    return {
      isOpen,
      closeModal,
      deleteDevice,
      showToast,
      toastMessage,
    };
  },
};
</script>

<style scoped>
/* Add any custom styles here if needed */
</style>
